import { render, staticRenderFns } from "./Desafio.vue?vue&type=template&id=2cf6bb67"
import script from "./Desafio.vue?vue&type=script&lang=js"
export * from "./Desafio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports